import { render, staticRenderFns } from "./BlockImage.vue?vue&type=template&id=5c4ed943&scoped=true"
import script from "./BlockImage.vue?vue&type=script&lang=js"
export * from "./BlockImage.vue?vue&type=script&lang=js"
import style0 from "./BlockImage.vue?vue&type=style&index=0&id=5c4ed943&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4ed943",
  null
  
)

export default component.exports